import React, { Component } from "react";
import { Link } from "react-router-dom";

import eAcademyLogo from "../../assets/img/logo/logo-colors.svg";
import yesserLogo from "../../assets/img/logo/Yesser-logo.svg";

import "./NavbarDefault.css";

export default class NavbarDefault extends Component {
  state = {
    url: "",
    style: "",
    navOpen: false,
    isMobile: false
  };
  showMenu = () => {
    this.setState({ isMobile: true, navOpen: !this.state.navOpen });
  };
  componentDidMount() {
    window.addEventListener("resize", this.isMobileView);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.isMobileView);
  }

  isMobileView = () => {
    window.innerWidth < 600
      ? this.setState({ isMobile: true })
      : this.setState({ isMobile: false });
  };

  render() {
    return (
      <>
        <div className="default-bg">
          <div className="menu" onClick={this.showMenu}>
            <div className="bars" />
          </div>

          <Link to="/" className="logo-mobile">
            <img src={eAcademyLogo} alt="logo in mobile" />
          </Link>

          <nav
            className={`nav-default ${
              this.state.navOpen && this.state.isMobile
                ? "nav-open"
                : "nav-close"
            } `}
          >
            <div className="logo has-text-centered">
              <Link to="/" className="logo-main">
                <img src={eAcademyLogo} alt="e-gov academy logo" />
              </Link>
              <Link to="/" className="logo-main">
                <img src={yesserLogo} alt="yesser logo" />
              </Link>

              {/* <a href="#" className="logo-main"> <img src={eAcademyLogo} alt=" e-gov academy logo" />
                        </a>
                        <a href="#" className="logo-second"> <img src={yesserLogo}
                            alt="yesser logo" /> </a> */}
            </div>
            <ul className="nav-list is-flex">
              <li className="nav-item">
                <Link to="/" className="nav-link" data-text="الرئيسية">
                  {" "}
                  الرئيسية{" "}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link" data-text="عن الأكاديمية">
                  {" "}
                  عن الأكاديمية{" "}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link" data-text="الأهداف">
                  {" "}
                  الأهداف{" "}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link" data-text="البرامج">
                  {" "}
                  البرامج{" "}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link" data-text="الانجازات">
                  {" "}
                  الانجازات{" "}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link" data-text="تواصل معنا">
                  {" "}
                  تواصل معنا{" "}
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </>
    );
  }
}
